import Vue from 'vue'
import VueTour from 'vue-tour'
import VueI18n from 'vue-i18n'
import VueGtag from 'vue-gtag'
import VueExpandableImage from 'vue-expandable-image'
import { Chart as ChartJS, registerables } from 'chart.js'
import { install } from 'resize-observer'
import '@mdi/font/css/materialdesignicons.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from '@/App'
import store from '@/store'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import Ads from 'vue-google-adsense'
import { ExceptionLog } from '@/services/ExceptionLogService.js'
import English from '../english.json'
import Gujarati from '../gujarati.json'
import Hindi from '../hindi.json'
import Marathi from '../marathi.json'
import Bengali from '../bengali.json'
import Kannada from '../Kannada.json'
import Punjabi from '../punjabi.json'
import Tamil from '../Tamil.json'
import Malayalam from '../Malayalam.json'
import Odia from '../Odia.json'

/** CSS */
import 'vuetify/dist/vuetify.min.css'
import 'vue-tour/dist/vue-tour.css'

// ============= ERROR HANDLERS =============

Vue.config.errorHandler = function (err, vm) {
	const currentTime = new Date().toISOString()

	const getComponentName = (vm) => {
		if (vm.$root === vm) return 'root'
		const name = vm._isVue
			? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag)
			: vm.name
		return (
			(name ? `<${name}>` : `anonymous component`) +
			(vm._isVue && vm.$options && vm.$options.__file ? ` at ${vm.$options.__file}` : '')
		)
	}

	const getFunctionName = (err) => {
		const stackLines = err.stack.split('\n')
		if (stackLines.length > 1) {
			const functionLine = stackLines[1].trim()
			const functionName = functionLine.split(' ')[1]
			return functionName
		}
		return 'unknown function'
	}

	const ErrorLog = {
		ErrorSource: getComponentName(vm) + getFunctionName(err),
		ErrorMessage: err.message || err.toString(),
		SystemErrorTime: currentTime,
		ErrorStack: JSON?.stringify(err?.stack),
		Attachments: ''
	}
	const formData = new FormData()
	for (const key in ErrorLog) {
		formData.append(key, ErrorLog[key])
	}

	ExceptionLog(formData)
	console.error('Vue Error:', ErrorLog)
}

// **NEW: Handle unhandled promise rejections**
window.addEventListener('unhandledrejection', event => {
	console.error('Unhandled Promise Rejection:', event.reason)

	// Log to your exception service
	const ErrorLog = {
		ErrorSource: 'Unhandled Promise Rejection',
		ErrorMessage: event.reason?.message || event.reason?.toString() || 'Unknown error',
		SystemErrorTime: new Date().toISOString(),
		ErrorStack: JSON.stringify(event.reason?.stack || ''),
		Attachments: ''
	}

	const formData = new FormData()
	for (const key in ErrorLog) {
		formData.append(key, ErrorLog[key])
	}

	ExceptionLog(formData)

	// **CRITICAL: Prevent the red error overlay**
	event.preventDefault()
})

// ============= REST OF YOUR CODE =============

if (!window.ResizeObserver) install()

ChartJS.register(...registerables)
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)

Vue.config.productionTip = false
Vue.prototype.$api = `${process.env.VUE_APP_BASE_URL}/api/d`;
Vue.prototype.$api_base = process.env.VUE_APP_BASE_URL
Vue.prototype.$secretKey = '@rk !nf0soft K*y'
Vue.use(VueExpandableImage)
Vue.use(
	VueGtag,
	{
		config: { id: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID },
		disableScriptLoad: process.env.NODE_ENV !== 'production',
		appName: 'Doctor diary'
	},
	router
)

Vue.use(VueTour)
Vue.use(VueI18n)

Vue.use(Toast, {
	transition: 'Vue-Toastification__bounce',
	maxToasts: 3,
	newestOnTop: true
})

const i18n = new VueI18n({
	messages: {
		English,
		Gujarati,
		Hindi,
		Marathi,
		Punjabi,
		Tamil,
		Odia,
		Kannada,
		Malayalam,
		Bengali
	}
})

store.watch(
	(state) => state.language,
	(newLanguage) => {
		i18n.locale = newLanguage
	},
	{ immediate: true }
)

async function initializeApp() {
	try {
		await store.dispatch('locationStore/RESTORE_FROM_STORAGE')

		store.dispatch('locationStore/GET_USER_LOCATION_DATA').catch(err => {
			console.warn('Failed to fetch fresh location data:', err)
		})

	} catch (error) {
		console.error('Failed to initialize location:', error)
	} finally {
		new Vue({
			render: (h) => h(App),
			router,
			store,
			vuetify,
			i18n
		}).$mount('#app')
	}
}

store.dispatch('features/updateAbhaStatusFromEnv');

initializeApp()